/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Ticketing destination of the notification rule, like Jira or ServiceNow
 */
export type PublicTicketingDestinationParamsDto = {
    /**
     * Name of the referenced template
     */
    templateName: string;
    type: PublicTicketingDestinationParamsDto.type;
};

export namespace PublicTicketingDestinationParamsDto {

    export enum type {
        JIRA = 'JIRA',
        SERVICENOW = 'SERVICENOW',
    }


}
